<template>
  <el-dialog v-model="dialogFormVisible">
    <el-form
      ref="elForm"
      size="medium"
      label-width="100px"
      label-position="right"
    >
      <el-form-item label="姓名">
        <el-input
          v-model="UserFormData.realName"
          prop="name"
          placeholder="请输入姓名"
          clearable
          :style="{ width: '100%' }"
        ></el-input>
      </el-form-item>
      <el-form-item label="邮箱">
        <el-input
          v-model="UserFormData.userName"
          prop="email"
          placeholder="请输入邮箱"
          clearable
          :style="{ width: '100%' }"
        >
        </el-input>
      </el-form-item>
      <el-form-item label="类型">
        <el-select
          v-model="UserFormData.role"
          placeholder="请选择用户类型"
          clearable
          :style="{ width: '100%' }"
        >
          <el-option v-for="item in roles" :value="item" :key="item">{{
            item
          }}</el-option>
        </el-select>
      </el-form-item>
      <el-form-item label="密码">
        <el-input
          v-model="UserFormData.password"
          prop="password"
          placeholder="请输入密码"
          show-password
          :style="{ width: '100%' }"
        ></el-input>
      </el-form-item>
    </el-form>

    <template #footer>
      <span class="dialog-footer">
        <el-button @click="dialogFormVisible = false">关闭</el-button>
        <el-button type="primary" @click="SubmitClick">保存</el-button>
      </span>
    </template>
  </el-dialog>
  <div class="container-fluid">
    <h3 class="text-dark mb-4">
      用户管理
      <button
        @click="ADDClick"
        class="btn btn-primary"
        type="button"
        style="margin: 0 0 0px 20px"
      >
        添加用户
      </button>
    </h3>
    <div class="card shadow">
      <div class="card-body">
        <div
          id="dataTable"
          class="table-responsive table mt-2"
          role="grid"
          aria-describedby="dataTable_info"
          style="overflow-y: hidden"
        >
          <div class="table-responsive">
            <table class="table">
              <thead>
                <tr>
                  <th style="width: auto">序号</th>
                  <th>姓名</th>
                  <th style="width: auto">邮箱</th>
                  <!-- <th style="width: auto">密码</th> -->
                  <th style="width: auto">用户角色</th>
                  <th>操作</th>
                </tr>
              </thead>
              <tbody>
                <tr :key="index" v-for="(item, index) in DataList">
                  <td>{{ index + 1 }}</td>
                  <td>{{ item.realName }}</td>
                  <td>{{ item.userName }}</td>
                  <!-- <td>{{ item.password }}</td> -->
                  <td>{{ item.role }}</td>
                  <td>
                    <a href="javascript:;" @click="ChangeClick(item)">修改</a
                    ><a
                      href="javascript:;"
                      @click="DeleteClick(item)"
                      style="margin: 0 10px 0"
                      >删除</a
                    >
                  </td>
                </tr>
              </tbody>
            </table>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import router from "../router/index";
import swal from "sweetalert2";
import "../common/httphelper";
import { AddUser, DeleteUser, GetUser, UpdateUser } from "../common/httphelper";
import "../common/role"
import getRole from '../common/role';

let defaultFormData = {
  userName: "",
  realName: "",
  password: "",
  role: "",
};

export default {
  data() {
    return {
      isModifly: false,
      DataList: [],
      dialogFormVisible: false,
      UserFormData: defaultFormData,
      roles: ["管理员", "产品开发部(修改)","产品开发部(审核)", "研发中心","财务","营销中心","其他"],
      role:{}
    };
  },
  setup() {},
  methods: {
    OpenPage() {
      router.push("ProductList");
    },
    ADDClick() {
      this.dialogFormVisible = true;
      this.UserFormData ={
        userName: "",
        realName: "",
        password: "",
        role: "",
      };
      this.isModifly = false;
    },

    ChangeClick(item) {
      this.dialogFormVisible = true;
      this.isModifly = true;
      this.UserFormData = JSON.parse(JSON.stringify(item));
    },

    async SubmitClick() {
      if (
        !(
          this.UserFormData.userName &&
          this.UserFormData.realName &&
          this.UserFormData.password &&
          this.UserFormData.role
        )
      ) {
        this.dialogFormVisible = false;
        await swal.fire({
          icon: "error",
          title: "请将表单填写完整",
          showConfirmButton: false,
          timer: 1500,
        });
        this.dialogFormVisible = true;
        return;
      }

      if(!this.EmailCheck(this.UserFormData.userName)){
        this.dialogFormVisible = false;
        await swal.fire({
          icon: "error",
          title: "请填写正确的邮箱地址！",
          showConfirmButton: false,
          timer: 1500,
        });
        this.dialogFormVisible = true;
        return;
      }

      if (this.isModifly) {
        UpdateUser(this.UserFormData).then(async(res) => {
          if (res.data) {
            this.successAciton();
          }else{
            this.dialogFormVisible = false;
            await swal.fire({
              icon: "error",
              title: "邮箱已被占用！",
              showConfirmButton: false,
              timer: 1500,
            });
            this.dialogFormVisible = true;
          }
        });
      } else {
        AddUser(this.UserFormData).then(async (res) => {
          if (res.data) {
            this.successAciton();
          } else {
            this.dialogFormVisible = false;
            await swal.fire({
              icon: "error",
              title: "邮箱已被占用！",
              showConfirmButton: false,
              timer: 1500,
            });
            this.dialogFormVisible = true;
          }
        });
      }
    },
    DeleteClick(item) {
      DeleteUser([item.id]).then((res) => {
        if (res.data) {
          let index = this.DataList.indexOf(item);
          this.DataList.splice(index, 1);
          swal.fire({
            icon: "success",
            title: "完成",
            showConfirmButton: false,
            timer: 1500,
          });
        }
      });
    },
    successAciton() {
      this.RefreshList();
      this.dialogFormVisible = false;
      swal.fire({
        icon: "success",
        title: "完成",
        showConfirmButton: false,
        timer: 1500,
      });
      this.UserFormData = {};
    },
    RefreshList() {
      GetUser().then((res) => {
        this.DataList = res.data;
      });
    },
    EmailCheck (str) {
      var emailStr=str;
      var emailPat=/^(.+)@(.+)$/;
      var matchArray=emailStr.match(emailPat);
      if (matchArray==null) {
        return false;
      }
      return true;
      }
  },
  mounted() {
    this.RefreshList();
    this.role=getRole()
  },
};
</script>

<style scoped>
a:not([href]):not([class]),
a:not([href]):not([class]):hover {
  color: #4e73df;
  text-decoration: underline;
  cursor: pointer;
}
</style>